var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cs from '../_util/classNames';
import { renderElem } from './util';
var ItemGroup = /** @class */ (function (_super) {
    __extends(ItemGroup, _super);
    function ItemGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, title = _a.title, level = _a.level, selectedKeys = _a.selectedKeys, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, theme = _a.theme, rest = __rest(_a, ["children", "title", "level", "selectedKeys", "prefixCls", "className", "style", "theme"]);
        var paddingStyle;
        var currentLevel;
        if (level === 1) {
            paddingStyle = { paddingLeft: (level - 1) * 20, fontWeight: '600' };
            currentLevel = level + 1;
        }
        else {
            paddingStyle =
                theme === 'light'
                    ? {
                        paddingLeft: (level - 1) * 20,
                        color: '#939aa3',
                    }
                    : {
                        paddingLeft: (level - 1) * 20,
                        color: '#ffffff',
                    };
            currentLevel = level;
        }
        var groupClassName = cs(prefixCls + "-group", className);
        return (React.createElement("div", { className: groupClassName, style: __assign({}, style) },
            React.createElement("div", { className: !className ? prefixCls + "-group-title" : prefixCls + "-group-title" },
                React.createElement("span", { style: paddingStyle }, title)),
            React.Children.map(children, function (child) {
                return renderElem(child, __assign(__assign({}, rest), { level: currentLevel, selectedKeys: selectedKeys,
                    prefixCls: prefixCls,
                    theme: theme }));
            })));
    };
    ItemGroup.propTypes = {
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    };
    ItemGroup.menuType = 'MenuGroup';
    return ItemGroup;
}(Component));
export default ItemGroup;
